import { render, staticRenderFns } from "./EndorsementReportChart.vue?vue&type=template&id=53372a2a&scoped=true&"
import script from "./EndorsementReportChart.vue?vue&type=script&lang=js&"
export * from "./EndorsementReportChart.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementReportChart.vue?vue&type=style&index=0&id=53372a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53372a2a",
  null
  
)

export default component.exports